import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.company.SelectRBPlanPopup', {
    header: 'Select Dext Prepare license',
    subscriptionsTitle: 'Please select which Dext Prepare license this organisation should be added to.',
    newTrialOption: 'Create a new organisation on a trial and create a subscription for it later',
});
